<div class="container my-3">
  <!-- <h1 class="mb-4">Edit Train</h1> -->
  <div class="row mt-4">
    <div class="col-sm-2" style="text-align: left">
      <button class="btn custom-buttons-btn ml-2" (click)="sendtoopdata()">
        Manage Opdata
      </button>
    </div>

    <div class="col-sm-2" style="text-align: left">
      <button class="btn custom-buttons-btn ml-2" (click)="sendtowarrenty()">
        Manage Warranty
      </button>
    </div>

    <div class="col-sm-2" style="text-align: left">
      <button class="btn custom-buttons-btn ml-2" (click)="sendToPrimaryG()">
        Primary Graph
      </button>
    </div>

    <div class="col-sm-2" style="text-align: left">
      <button class="btn custom-buttons-btn ml-2" (click)="sendToWarrantiesG()">
        Warranties Graph
      </button>
    </div>

    <div class="col-sm-2" style="text-align: left">
      <button class="btn custom-buttons-btn ml-2" (click)="sendToCustomG()">
        Custom Graph
      </button>
    </div>
  </div>
  <!-- Form Start -->
  <div class="row">
    <div style="padding: 10px"></div>
  </div>
  <div>
    <form #form="ngForm" (ngSubmit)="updatetrain()">
      <div>
        <!-- Commented on 20th april 2026 for the breadcrumb changes -->
        <!-- <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="name" class="form-label">Plant :</label>
          </div>
          <div class="col-sm-4">
            <select
              class="form-select border border-dark"
              name="plantid"
              [(ngModel)]="trainDetails.PlantId"
            >
              <option
                *ngFor="let plant of plants"
                [value]="plant.Id"
                [selected]="plant.Id === trainDetails.PlantId"
              >
                {{ plant.Name }}
              </option>
            </select>
          </div>
        </div> -->

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="name" class="form-label">Name</label>
          </div>
          <div class="col-sm-4">
            <input
              type="text"
              class="form-control border border-dark"
              id="name"
              name="name"
              [(ngModel)]="trainDetails.Name"
              autocomplete="on"
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="AccessOptions" class="form-label">User Access:</label>
          </div>
          <div class="col-sm-4">
            <select
              class="form-select border border-dark"
              [(ngModel)]="trainDetails.AccessOption"
              name="AccessOption"
              id="AccessOption"
              (change)="onAccessOptionSelected($event)"
            >
              <option
                *ngFor="let access of useraccessOption"
                [selected]="access.Id === trainDetails.AccessOption"
                [value]="access.Id"
              >
                {{ access.Name }}
              </option>
            </select>
          </div>
        </div>

        <div>
          <div class="row mb-3" id="divUser">
            <div class="col-sm-3" style="text-align: left">
              <a
                (click)="showemployee(template)"
                style="
                  margin-top: 25px;
                  font-weight: bolder;
                  color: rgb(24, 183, 24);
                "
                >+ Add User(s)</a
              >
            </div>
            <div class="col-sm-4">
              <div class="newcontainer">
                <div *ngFor="let user of selectedUser" class="user">
                  {{ user.FirstName }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="notes" class="form-label">Notes:</label>
          </div>
          <div class="col-sm-4">
            <input
              type="text"
              class="form-control border border-dark"
              id="notes"
              name="Notes"
              [(ngModel)]="trainDetails.Notes"
              autocomplete="on"
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="name" class="form-label">Unit</label>
          </div>
          <div class="col-sm-4">
            <select
              class="form-select border border-dark"
              [(ngModel)]="trainDetails.Units"
              name="Type"
            >
              <option
                *ngFor="let unit of units"
                [value]="unit.Id"
                [selected]="unit.Id === trainDetails.Units"
              >
                {{ unit.UnitName }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="stage" class="form-label"># of Stages</label>
          </div>
          <div class="col-sm-4">
            <select
              class="form-select border border-dark"
              [(ngModel)]="trainDetails.Stages"
              name="stage"
              (change)="onOptionSelected()"
            >
              <option
                *ngFor="let stages of stage"
                [value]="stages.Id"
                [selected]="stages.Id === trainDetails.Stages"
              >
                {{ stages.Name }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="tcfa" class="form-label">TCFA</label>
          </div>
          <div class="col-sm-4">
            <input
              type="text"
              class="form-control border border-dark"
              id="tcfa"
              name="tcfa"
              [(ngModel)]="trainDetails.Tcfa"
              autocomplete="on"
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="tcfb" class="form-label">TCFB</label>
          </div>
          <div class="col-sm-4">
            <input
              type="text"
              class="form-control border border-dark"
              id="tcfb"
              name="tcfb"
              [(ngModel)]="trainDetails.Tcfb"
              autocomplete="on"
            />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <b>Stage 1</b>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="hybrid" class="form-label">Hybrid</label>
          </div>
          <div class="col-sm-4">
            <select
              class="form-select border border-dark"
              [(ngModel)]="trainDetails.Hybrid"
              name="hybrid"
              (change)="onOptionHybrid()"
            >
              <option
                *ngFor="let hybrids of hybrid"
                [value]="hybrids.Id"
                [selected]="hybrids.Id === trainDetails.Hybrid"
              >
                {{ hybrids.Name }}
              </option>
            </select>
          </div>
        </div>

        <div id="stage1Nhybrid" *ngIf="showHybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="hybrid" class="form-label">Element1:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage1Element1Model"
                name="s1m1"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model of models"
                  [value]="model.Id"
                  [selected]="model.Id === trainDetails.Stage1Element1Model"
                >
                  {{ model.Name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s1EVessels" class="form-label"
                >Elements/Vessels</label
              >
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="Stage1ElementsVesselNH"
                name="Stage1ElementsVesselNH"
                [(ngModel)]="trainDetails.Stage1ElementsVessel"
                autocomplete="on"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s1Vessels" class="form-label"># Of Vessels</label>
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="s1Vessels"
                name="s1Vessels"
                [(ngModel)]="trainDetails.Stage1Vessels"
                autocomplete="on"
              />
            </div>
          </div>
        </div>

        <div id="stage1hybrid" *ngIf="showStage1hybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element1:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage1Element1Model"
                name="s1m1"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model of models"
                  [value]="model.Id"
                  [selected]="model.Id === trainDetails.Stage1Element1Model"
                >
                  {{ model.Name }}
                </option>
              </select>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys1m1" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3" style="text-align: left">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys1m1"
                name="quantitys1m1"
                [(ngModel)]="trainDetails.Stage1Element1Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage1()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element2:</label>
            </div>

            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage1Element2Model"
                name="s1m2"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model1 of models"
                  [value]="model1.Id"
                  [selected]="model1.Id === trainDetails.Stage1Element2Model"
                >
                  {{ model1.Name }}
                </option>
              </select>
            </div>

            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys1m2" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys1m2"
                name="quantitys1m2"
                [(ngModel)]="trainDetails.Stage1Element2Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage1()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element3:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage1Element3Model"
                name="s1m3"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model2 of models"
                  [value]="model2.Id"
                  [selected]="model2.Id === trainDetails.Stage1Element3Model"
                >
                  {{ model2.Name }}
                </option>
              </select>
            </div>

            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys1m3" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys1m3"
                name="quantitys1m3"
                [(ngModel)]="trainDetails.Stage1Element3Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage1()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s1Vesselshybrid" class="form-label"
                >Elements/Vessels</label
              >
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="elementvessels1hybrid"
                name="elementvessels1"
                [(ngModel)]="trainDetails.Stage1ElementsVessel"
                [disabled]="true"
                autocomplete="on"
              />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s1Vesselshybrid" class="form-label"
                ># Of Vessels</label
              >
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="s1Vesselshybrid"
                name="s1Vessels"
                [(ngModel)]="trainDetails.Stage1Vessels"
                autocomplete="on"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- stage 2 Starts -->
      <div id="stage2" *ngIf="showDiv">
        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <b>Stage 2</b>
          </div>
          <div class="col-sm-4"></div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="hybridS2" class="form-label">Hybrid</label>
          </div>
          <div class="col-sm-4">
            <select
              class="form-select border border-dark"
              [(ngModel)]="trainDetails.Hybrid2"
              name="Hybrid2"
              (change)="onOptionHybridS2()"
            >
              <option
                *ngFor="let hybrids2 of hybridSt2"
                [value]="hybrids2.Id"
                [selected]="hybrids2.Id === trainDetails.Hybrid2"
              >
                {{ hybrids2.Name }}
              </option>
            </select>
          </div>
        </div>

        <!-- stage 2 non hybrid -->
        <div id="stage2Nhybrid" *ngIf="stage2Nhybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="hybridS2" class="form-label">Element1:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage2ElementModel"
                name="s2m1"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model of models"
                  [value]="model.Id"
                  [selected]="model.Id === trainDetails.Stage2ElementModel"
                >
                  {{ model.Name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="Stage2ElementsVessel" class="form-label"
                >Elements/Vessels</label
              >
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="Stage2ElementsVessel"
                name="Stage2EV"
                [(ngModel)]="trainDetails.Stage2ElementsVessel"
                autocomplete="on"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s2Vessels" class="form-label"># Of Vessels</label>
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="s2Vessels"
                name="s2Vessels"
                [(ngModel)]="trainDetails.Stage2Vessels"
                autocomplete="on"
              />
            </div>
          </div>
        </div>

        <!-- stage 2 hybrid -->
        <div id="stage2hybrid" *ngIf="showStage2hybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element1:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage2ElementModel"
                name="s2m1"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model of models"
                  [value]="model.Id"
                  [selected]="model.Id === trainDetails.Stage2ElementModel"
                >
                  {{ model.Name }}
                </option>
              </select>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys2m1" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3" style="text-align: left">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys2m1"
                name="quantitys2m1"
                [(ngModel)]="trainDetails.Stage2Element1Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage2()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element2:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage2Element2Model"
                name="s2m2"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model1 of models"
                  [value]="model1.Id"
                  [selected]="model1.Id === trainDetails.Stage2Element2Model"
                >
                  {{ model1.Name }}
                </option>
              </select>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys2m2" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys2m2"
                name="quantitys2m2"
                [(ngModel)]="trainDetails.Stage2Element2Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage2()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element3:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage2Element3Model"
                name="s2m3"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model2 of models"
                  [value]="model2.Id"
                  [selected]="model2.Id === trainDetails.Stage2Element3Model"
                >
                  {{ model2.Name }}
                </option>
              </select>
            </div>

            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys2m3" class="form-label">Qty:</label>
            </div>

            <div class="col-sm-3">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys2m3"
                name="quantitys2m3"
                [(ngModel)]="trainDetails.Stage2Element3Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage2()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s1Vesselshybrid" class="form-label"
                >Elements/Vessels</label
              >
            </div>

            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="elementvessels2hybrid"
                name="elementvessels2"
                [(ngModel)]="trainDetails.Stage2ElementsVessel"
                autocomplete="on"
                [disabled]="true"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s2Vesselshybrid" class="form-label"
                ># Of Vessels</label
              >
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="s1Vesselshybrid"
                name="s2Vessels"
                [(ngModel)]="trainDetails.Stage2Vessels"
                autocomplete="on"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- stage 2 Ends -->

      <!--stage 3 Starts -->
      <div id="stage3" *ngIf="showDiv2">
        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <b>Stage 3</b>
          </div>
          <div class="col-sm-4"></div>
        </div>

        <div class="row mb-3">
          <div class="col-sm-3" style="text-align: left">
            <label for="hybridS2" class="form-label">Hybrid</label>
          </div>
          <div class="col-sm-4">
            <select
              class="form-select border border-dark"
              [(ngModel)]="trainDetails.Hybrid3"
              name="Hybrid2"
              (change)="onOptionHybridS3()"
            >
              <option
                *ngFor="let hybrids3 of hybridSt3"
                [value]="hybrids3.Id"
                [selected]="hybrids3.Id === trainDetails.Hybrid3"
              >
                {{ hybrids3.Name }}
              </option>
            </select>
          </div>
        </div>

        <!-- stage 3 non hybrid -->
        <div id="stage3Nhybrid" *ngIf="stage3Nhybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="hybridS3" class="form-label">Element1:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage3ElementModel"
                name="s3m1"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model of models"
                  [value]="model.Id"
                  [selected]="model.Id === trainDetails.Stage3ElementModel"
                >
                  {{ model.Name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s3Vessels" class="form-label">Elements/Vessels</label>
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="elementvessels3"
                name="elementvessels3"
                [(ngModel)]="trainDetails.Stage3ElementsVessel"
                autocomplete="on"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s3Vessels" class="form-label"># Of Vessels</label>
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="s3Vessels"
                name="s3Vessels"
                [(ngModel)]="trainDetails.Stage3Vessels"
                autocomplete="on"
              />
            </div>
          </div>
        </div>

        <!-- stage 3 hybrid -->
        <div id="stage3hybrid" *ngIf="showStage3hybrid">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element1:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage3ElementModel"
                name="s3m1"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model of models"
                  [value]="model.Id"
                  [selected]="model.Id === trainDetails.Stage3ElementModel"
                >
                  {{ model.Name }}
                </option>
              </select>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys3m1" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3" style="text-align: left">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys3m1"
                name="quantitys3m1"
                [(ngModel)]="trainDetails.Stage3Element1Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage3()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element2:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage3Element2Model"
                name="s3m2"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model1 of models"
                  [value]="model1.Id"
                  [selected]="model1.Id === trainDetails.Stage3Element2Model"
                >
                  {{ model1.Name }}
                </option>
              </select>
            </div>
            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys3m2" class="form-label">Qty:</label>
            </div>
            <div class="col-sm-3">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys3m2"
                name="quantitys3m2"
                [(ngModel)]="trainDetails.Stage3Element2Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage3()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="name" class="form-label">Element3:</label>
            </div>
            <div class="col-sm-4">
              <select
                class="form-select border border-dark"
                [(ngModel)]="trainDetails.Stage3Element3Model"
                name="s3m3"
              >
                <option [value]="0">Select a Model</option>
                <option
                  *ngFor="let model3 of models"
                  [value]="model3.Id"
                  [selected]="model3.Id === trainDetails.Stage3Element3Model"
                >
                  {{ model3.Name }}
                </option>
              </select>
            </div>

            <div class="col-sm-1" style="text-align: left">
              <label for="quantitys3m3" class="form-label">Qty:</label>
            </div>

            <div class="col-sm-3">
              <input
                type="text"
                class="form-control border border-dark"
                id="quantitys3m3"
                name="quantitys3m3"
                [(ngModel)]="trainDetails.Stage3Element3Qty"
                autocomplete="on"
                (change)="QuantityAdditionStage3()"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s3Vesselshybrid" class="form-label"
                >Elements/Vessels</label
              >
            </div>

            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="elementvessels3hybrid"
                name="elementvessels3"
                [(ngModel)]="trainDetails.Stage3ElementsVessel"
                autocomplete="on"
                [disabled]="true"
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: left">
              <label for="s3Vesselshybrid" class="form-label"
                ># Of Vessels</label
              >
            </div>
            <div class="col-sm-4">
              <input
                type="text"
                class="form-control border border-dark"
                id="s1Vesselshybrid"
                name="s2Vessels"
                [(ngModel)]="trainDetails.Stage3Vessels"
                autocomplete="on"
              />
            </div>
          </div>
        </div>
      </div>
      <!--stage 3 Ends -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <b>User Defined Fields:</b>
        </div>
      </div>
      <!-- user defined field 1 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud1" class="form-label">Field 1:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control border border-dark"
            id="Field1"
            name="Field1"
            [(ngModel)]="trainDetails.Ud1"
            autocomplete="on"
          />
        </div>
      </div>
      <!-- user defined field 2 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud2" class="form-label">Field 2:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control border border-dark"
            id="Field2"
            name="Field2"
            [(ngModel)]="trainDetails.Ud2"
            autocomplete="on"
          />
        </div>
      </div>
      <!-- user defined field 3 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud3" class="form-label">Field 3:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control border border-dark"
            id="Field3"
            name="Field3"
            [(ngModel)]="trainDetails.Ud3"
            autocomplete="on"
          />
        </div>
      </div>
      <!-- user defined field 4 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud4" class="form-label">Field 4:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control border border-dark"
            id="Field4"
            name="Field4"
            [(ngModel)]="trainDetails.Ud4"
            autocomplete="on"
          />
        </div>
      </div>
      <!-- user defined field 5 -->
      <div class="row mb-3">
        <div class="col-sm-3" style="text-align: left">
          <label for="ud4" class="form-label">Field 5:</label>
        </div>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control border border-dark"
            id="Field5"
            name="Field5"
            [(ngModel)]="trainDetails.Ud5"
            autocomplete="on"
          />
        </div>
      </div>
      

 <form [formGroup]="operationForm">
  <div class="row mb-3">
    <div class="col-sm-3" style="text-align: left">
      <label class="form-label">Reference Point:</label>
    </div>

    <div class="col-sm-4">
    
            <div class="input-group position-relative">
              <input
                matInput
                [matDatepicker]="picker"
                [matDatepickerFilter]="dateFilter"
                type="text"
                formControlName="datetime"
                placeholder="M/d/yyyy HH:mm:ss"
                class="form-control border border-dark"
                (dateInput)="dateSelected($event)"
                (dateChange)="dateSelected($event)"
                readonly
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

           
              <mat-datepicker
                #picker
                startView="multi-year"
                (yearSelected)="chosenYearHandler($event)"
                (monthSelected)="chosenMonthHandler($event)">
              </mat-datepicker>

             
              <div *ngIf="datepickerLoading" class="overlay position-absolute">
                <mat-progress-spinner
                  color="primary"
                  mode="indeterminate"
                  diameter="40">
                </mat-progress-spinner>
              </div>
            </div>
        

       
        <select
          class="d-none"
          formControlName="time"
          (change)="onTimeChange($event)">
          <option value="" disabled>Select Time</option>
          <option *ngFor="let t of timeList" [value]="t">{{ t }}</option>
        </select>

       
      
      </div>

  </div>

  
</form>

<!-- Custom Time Panel injected next to Calendar -->
<ng-template #timePanel>
  <div class="custom-time-panel">
    <ul>
      <li
        *ngFor="let t of timeList"
        (click)="onTimeChangeManual(t)"
        [class.active]="operationForm.get('time')?.value === t">
        {{ t }}
      </li>
    </ul>
  </div>
</ng-template>
     

      <div>
        <div style="text-align: center">
          <button type="submit" class="btn custom-buttons-btn m-2">Update</button>
         
          <button
            type="button"
            class="btn custom-buttons-btn m-2"
            (click)="duplicateTrain()"
          >
            Duplicate
          </button>
        
          <button
            type="button"
            class="btn custom-delete-btn m-2"
            (click)="deleteTrain(trainDetails.Id)"
          >
            Delete
          </button>
        </div>
      </div>

      <ng-template #template>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="modal-basic-title">User Selection</h4>
              <button
                type="button"
                class="close"
                aria-label="Cancel"
                (click)="close()"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label
                style="text-align: center; font-size: 15px; font-weight: bolder"
                *ngIf="trainDetails.AccessOption == 1"
              >
                Select User(s) to restrict access for this train.
              </label>
              <label
                style="text-align: center; font-size: 15px; font-weight: bolder"
                *ngIf="trainDetails.AccessOption == 0"
              >
                Select User(s) to permit access for this train.
              </label>
              <div class="row">
                <div>
                  <div class="ngselect" style="padding: 5px"></div>
                  <label style="font-size: 15px">Users List</label>
                  <ng-select
                    appendTo=".modal-body"
                    [items]="comanyUsers"
                    appearance="inline"
                    bindLabel="FirstName"
                    [multiple]="true"
                    placeholder="Select"
                    [(ngModel)]="selectedUser"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="selecteduser($event)"
                    [isOpen]="true"
                  >
                  </ng-select>
                </div>
              </div>

              <div class="row">
                <div style="padding: 125px"></div>
              </div>

              <div class="row">
                <div class="col-md-12 mt-2">
                  <button class="btn custom-buttons-btn" (click)="updatetrain()">
                    Ok
                  </button>
                  <button
                    class="btn custom-buttons-btn"
                    style="margin-left: 5px"
                    (click)="close()"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </form>
  </div>
</div>
